import { createI18n } from 'vue-i18n';
import axios from '@/lib/axios';

const { locale } = window.mds || {};
const currentLocale = locale || 'en';

const messages = {};
const vueI18n = createI18n({
  legacy: false,
  locale: currentLocale,
  messages,
});

const getI18N = () => {
  axios.get('/website/i18n')
    .then((res) => {
      const { data } = res;
      if (data && data[currentLocale]) {
        vueI18n.global.setLocaleMessage(
          currentLocale,
          { ...data[currentLocale] },
        );
      }
    }).catch(() => {});
};
getI18N();

export default vueI18n;
